var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWrapperOptions',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" Save Selection ")]},proxy:true}])},_vm._l((3),function(id){return _c('LoadGameEntry',{key:id,staticClass:"c-entry-border",attrs:{"save-id":id - 1}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }